module.exports = __webpack_public_path__ + "img/20231123152639660a52.5f31cb26.jpg";